export default __webpack_public_path__ + "static/media/pelikin_logo_scaled.e1da3ffb.png";